export default class ModalRepreController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('~/scripts/services/model/repre').default[]} repre
	 */
	constructor($uibModalInstance, repre) {
		this.$uibModalInstance = $uibModalInstance;
		this.repre = repre.map((/** @type {import('~/scripts/services/model/repre').default} */ r) => ({ ...r }));
		this.tmp = null;
	}

	cancel() {
		this.$uibModalInstance.dismiss('cancel');
	}

	submit() {
		this.$uibModalInstance.close({ repre: this.repre });
	}
}
